import React, { Component } from 'react';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import axios from 'axios';
import { EventEmitter } from './events';
import Spinner from './helpers/spinnerhelper';

class CheckboxComponent extends Component {
	constructor(props) {
		super();

		this.state = {
            isChecked: false,
            CmsWriter: "",
            isLoading: false
        }        
    }

    componentDidMount() { 
        this.setState({ isChecked: this.props.data.data.event.status == "Complete" });
    }    

    toggle = () => {  
        let apiUrl = JSON.parse(localStorage.getItem('api'));
        let userSession = JSON.parse(localStorage.getItem('userSession'));

        let status = !this.state.isChecked ? "Complete" : "Open";
        let data = {
            ...this.props.data,
            data : {
                ...this.props.data.data,
                event: {
                    ...this.props.data.data.event,
                    status: status,
                    completedDate: status === 'Complete' ? new Date() : '',
                    completedBy: status === 'Complete' ? userSession.userName : '',
                    lastUpdatedBy: userSession.userName,
                    lastUpdatedDate: new Date()
                }
            },
            partitionKey: 'WorkFlow'
		}   

        this.setState({ isLoading: true }, () => {
            axios({
                method: 'post',
                url: apiUrl.CmsWriter + '&token=' + apiUrl.tenantToken + '&partitionKey=WorkFlow&validateSchema=false',
                data: data,

            }).then((response) => {
                this.setState({
                    isChecked: !this.state.isChecked,
                    isLoading: false
                }, () => {
                    EventEmitter.dispatch("onMarkCompleted", data.id);
                });
            });	
        });
	}

	render() {
        return (
            <>
                <Spinner visible={this.state.isLoading}/>
                <Checkbox	
				    checked={this.state.isChecked}
				    label="Mark as complete"				
                    onChange={this.toggle}
                    className='complete-checkbox'
                    />
            </>
		);
	}
}

export default CheckboxComponent;